import { Button } from "@/components/ui/Button";
import { useWebsocketContext } from "@/lib/WebsocketProvider";
import { useGameStore } from "@/store";
import clsx from "clsx";
import { Link, useParams } from "react-router";

// @ts-expect-error figure this out later
import br1Image from "../../images/pieces/br1.png";
// @ts-expect-error figure this out later
import bn1Image from "../../images/pieces/bn1.png";
// @ts-expect-error figure this out later
import bb1Image from "../../images/pieces/bb1.png";
// @ts-expect-error figure this out later
import bq1Image from "../../images/pieces/bq1.png";
// @ts-expect-error figure this out later
import bk1Image from "../../images/pieces/bk1.png";
// @ts-expect-error figure this out later
import bb2Image from "../../images/pieces/bb2.png";
// @ts-expect-error figure this out later
import bn2Image from "../../images/pieces/bn2.png";
// @ts-expect-error figure this out later
import br2Image from "../../images/pieces/br2.png";

// @ts-expect-error figure this out later
import bp1Image from "../../images/pieces/bp1.png";
// @ts-expect-error figure this out later
import bp2Image from "../../images/pieces/bp2.png";
// @ts-expect-error figure this out later
import bp3Image from "../../images/pieces/bp3.png";
// @ts-expect-error figure this out later
import bp4Image from "../../images/pieces/bp4.png";
// @ts-expect-error figure this out later
import bp5Image from "../../images/pieces/bp5.png";
// @ts-expect-error figure this out later
import bp6Image from "../../images/pieces/bp6.png";
// @ts-expect-error figure this out later
import bp7Image from "../../images/pieces/bp7.png";
// @ts-expect-error figure this out later
import bp8Image from "../../images/pieces/bp8.png";

// @ts-expect-error figure this out later
import wr1Image from "../../images/pieces/wr1.png";
// @ts-expect-error figure this out later
import wn1Image from "../../images/pieces/wn1.png";
// @ts-expect-error figure this out later
import wb1Image from "../../images/pieces/wb1.png";
// @ts-expect-error figure this out later
import wq1Image from "../../images/pieces/wq1.png";
// @ts-expect-error figure this out later
import wk1Image from "../../images/pieces/wk1.png";
// @ts-expect-error figure this out later
import wb2Image from "../../images/pieces/wb2.png";
// @ts-expect-error figure this out later
import wn2Image from "../../images/pieces/wn2.png";
// @ts-expect-error figure this out later
import wr2Image from "../../images/pieces/wr2.png";

// @ts-expect-error figure this out later
import wp1Image from "../../images/pieces/wp1.png";
// @ts-expect-error figure this out later
import wp2Image from "../../images/pieces/wp2.png";
// @ts-expect-error figure this out later
import wp3Image from "../../images/pieces/wp3.png";
// @ts-expect-error figure this out later
import wp4Image from "../../images/pieces/wp4.png";
// @ts-expect-error figure this out later
import wp5Image from "../../images/pieces/wp5.png";
// @ts-expect-error figure this out later
import wp6Image from "../../images/pieces/wp6.png";
// @ts-expect-error figure this out later
import wp7Image from "../../images/pieces/wp7.png";
// @ts-expect-error figure this out later
import wp8Image from "../../images/pieces/wp8.png";
import {
  flipBoard,
  getAvailableMoves,
  getAvailableTileMoves,
  getIsKingInCheck,
  getPlayerTurn,
  getPossibleOpponentMoveLocations,
  TILE_REMOVAL_LOCATIONS,
} from "@/lib/pieces";
import {
  getReversedSquareId,
  getSquareId,
  PLAYER_COLOR,
  TILE_STATE,
  type BoardSquareData,
  type BoardSquareID,
} from "@/lib/room";
import { useMemo, useState } from "react";

const IMAGE_MAP = {
  br1: br1Image,
  bn1: bn1Image,
  bb1: bb1Image,
  bq1: bq1Image,
  bk1: bk1Image,
  bb2: bb2Image,
  bn2: bn2Image,
  br2: br2Image,
  bp1: bp1Image,
  bp2: bp2Image,
  bp3: bp3Image,
  bp4: bp4Image,
  bp5: bp5Image,
  bp6: bp6Image,
  bp7: bp7Image,
  bp8: bp8Image,
  wr1: wr1Image,
  wn1: wn1Image,
  wb1: wb1Image,
  wq1: wq1Image,
  wk1: wk1Image,
  wb2: wb2Image,
  wn2: wn2Image,
  wr2: wr2Image,
  wp1: wp1Image,
  wp2: wp2Image,
  wp3: wp3Image,
  wp4: wp4Image,
  wp5: wp5Image,
  wp6: wp6Image,
  wp7: wp7Image,
  wp8: wp8Image,
};

function HasNotJoinedRoomView() {
  const { id } = useParams();
  const websocket = useWebsocketContext();

  return (
    <div className="h-screen w-screen overflow-hidden grid place-items-center">
      <div className="fixed inset-x-0 top-6 flex items-center justify-center">
        <Link to="/">
          <Button>Back Home</Button>
        </Link>
      </div>
      <Button
        onClick={() => {
          websocket?.emit("ROOM_JOIN", {
            id,
          });
        }}>
        Join Room
      </Button>
    </div>
  );
}

function WaitingRoomView() {
  const userId = useGameStore((store) => store.userId)!;
  const room = useGameStore((store) => store.room)!;
  const websocket = useWebsocketContext();

  const canStartGame =
    room.userIds.includes(userId) && room.userIds.length === 2;

  return (
    <div className="grid place-items-center h-screen w-screen p-4">
      <div className="border border-dashed p-6 max-w-md w-full">
        <h2 className="font-handwriting">Players</h2>
        <ul>
          {room.userIds.map((id) => (
            <li key={id}>{id}</li>
          ))}
        </ul>
        {room.spectatorUserIds && (
          <>
            <h2 className="mt-4 font-handwriting">Spectators</h2>
            <ul>
              {room.spectatorUserIds.map((id) => (
                <li key={id}>{id}</li>
              ))}
            </ul>
          </>
        )}
        {canStartGame && (
          <Button
            className="mt-4"
            onClick={() => {
              websocket?.emit("ROOM_GAME_START", {
                id: room.id,
              });
            }}>
            Start Game
          </Button>
        )}
      </div>
    </div>
  );
}

interface GameBoardSquareProps {
  square: BoardSquareData;
  isWhiteSquare: boolean;
  isSelected?: boolean;
  isKingInCheck?: boolean;
  isAvailableMove?: boolean;
  isTurn?: boolean;
  onClick?: () => void;
}

function GameBoardSquare({
  isWhiteSquare,
  isSelected,
  isKingInCheck,
  isAvailableMove,
  isTurn,
  onClick,
  square,
}: GameBoardSquareProps) {
  const isGap = square?.state === TILE_STATE.GAP;

  const isPiece =
    square.state !== TILE_STATE.GAP && square.state !== TILE_STATE.EMPTY;

  return (
    <div
      className={clsx(
        "border-4 size-tile-square grid place-items-center relative",
        {
          "bg-white": isWhiteSquare,
          "bg-[#D0D0D0]": !isWhiteSquare,
          "border-white": isWhiteSquare && !isSelected && !isKingInCheck,
          "border-[#D0D0D0]": !isWhiteSquare && !isSelected && !isKingInCheck,
          "border-blue-600": isTurn && isSelected,
          "border-gray-600": !isTurn && isSelected,
          "border-red-600": isKingInCheck && !isSelected,
          "!bg-black !border-black": isGap,
        }
      )}
      onClick={onClick}>
      {isPiece && (
        <img
          className="size-tile-square-image"
          // @ts-expect-error figure this out later
          src={IMAGE_MAP[square?.image]}
        />
      )}
      {/*{isDestinationForOpponent && (
      <div className="absolute inset-0 pointer-events-none grid place-items-center">
        <div
          className={clsx("rounded-full size-4 bg-gray-600/40")}
        />
      </div>
    )}*/}
      {/*{isDestinationForPlayer && (
      <div className="absolute inset-0 pointer-events-none grid place-items-center">
        <div
          className={clsx(
            "rounded-full size-4 bg-green-600/40"
          )}
        />
      </div>
    )}*/}
      {isAvailableMove && (
        <div className="absolute inset-0 pointer-events-none grid place-items-center">
          <div
            className={clsx("rounded-full size-4", {
              "bg-blue-600": isTurn,
              "bg-gray-600": !isTurn,
            })}
          />
        </div>
      )}
    </div>
  );
}

const SQUARES = new Array(8).fill(null);
const TILES = new Array(4).fill(null);

function TileRemovalView() {
  const userId = useGameStore((store) => store.userId)!;
  const room = useGameStore((store) => store.room)!;
  const websocket = useWebsocketContext();

  const isWhite = userId === room.whiteUserId;
  const isBlack = userId === room.blackUserId;

  const userColor = isWhite ? PLAYER_COLOR.WHITE : PLAYER_COLOR.BLACK;
  const playerTurn = getPlayerTurn(room.turn);

  const isTurn = playerTurn === userColor;

  const [selectedTile, setSelectedTile] = useState<null | [number, number]>(
    null
  );

  const blowUpTile = () => {
    if (!selectedTile) return;

    websocket?.emit("ROOM_GAME_MAKE_TILE_REMOVAL_MOVE", {
      id: room.id,
      tile: selectedTile,
    });

    setSelectedTile(null);
  };

  return (
    <div className="grid place-items-center h-screen w-screen p-4">
      <div>
        <div className="flex flex-col items-center justify-center gap-2 mb-8">
          <div className="font-handwriting text-2xl text-center">
            {isTurn ? "Choose a tile to remove" : "Black is removing a tile"}
          </div>
        </div>
        <div className="border-2 border-solid w-fit">
          {TILES.map((_, tileRowIndex) => (
            <div key={tileRowIndex} className="grid grid-cols-4">
              {TILES.map((_, tileColumnIndex) => {
                const rowSquares = new Array(2)
                  .fill(tileRowIndex)
                  .map((tileIndex, index) => tileIndex * 2 + index);
                const columnSquares = new Array(2)
                  .fill(tileColumnIndex)
                  .map((tileIndex, index) => tileIndex * 2 + index);

                const availableMove = TILE_REMOVAL_LOCATIONS.find(
                  (move) =>
                    move[0] === tileRowIndex && move[1] === tileColumnIndex
                );

                const isSelectedTile =
                  selectedTile?.[0] === tileRowIndex &&
                  selectedTile?.[1] === tileColumnIndex;

                return (
                  <div
                    className={clsx(
                      "tile-size border-1 border-black border-solid relative transition-all",
                      {
                        "shadow-2xl -translate-y-1": isSelectedTile,
                      }
                    )}
                    onClick={() => {
                      if (!isBlack) return;

                      if (!availableMove) {
                        setSelectedTile(null);
                        return;
                      }

                      setSelectedTile([tileRowIndex, tileColumnIndex]);
                    }}>
                    {isSelectedTile && (
                      <div className="absolute shadow-xl inset-0 z-10 pointer-events-none"></div>
                    )}
                    {!!availableMove && (
                      <div className="absolute inset-0 pointer-events-none grid place-items-center z-10">
                        <div
                          className={clsx("rounded-full size-4", {
                            "bg-blue-600": isTurn,
                            "bg-gray-600": !isTurn,
                          })}
                        />
                      </div>
                    )}
                    {rowSquares.map((rowIndex) => (
                      <div key={rowIndex} className="grid grid-cols-2">
                        {columnSquares.map((columnIndex) => {
                          const squareId = isWhite
                            ? getSquareId(rowIndex, columnIndex)
                            : getReversedSquareId(rowIndex, columnIndex);
                          const square = room.board.get(squareId);

                          const isWhiteSquare =
                            (rowIndex + columnIndex) % 2 === 0;

                          return (
                            <GameBoardSquare
                              key={`${rowIndex}:${columnIndex}`}
                              square={square!}
                              isWhiteSquare={isWhiteSquare}
                            />
                          );
                        })}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div className="flex gap-2 items-center justify-center w-full mt-4">
          <Button
            onClick={() => {
              if (!isTurn) return;
              blowUpTile();
            }}>
            Remove
          </Button>
        </div>
      </div>
    </div>
  );
}

function GameInProgressView() {
  const userId = useGameStore((store) => store.userId)!;
  const room = useGameStore((store) => store.room)!;
  const websocket = useWebsocketContext();

  const isWhite = userId === room.whiteUserId;
  const isBlack = userId === room.blackUserId;

  const userColor = isWhite ? PLAYER_COLOR.WHITE : PLAYER_COLOR.BLACK;
  const opponentColor = isWhite ? PLAYER_COLOR.BLACK : PLAYER_COLOR.WHITE;
  const playerTurn = getPlayerTurn(room.turn);

  const isTurn = playerTurn === userColor;

  const [moveMode, setMoveMode] = useState<"piece" | "tile">("piece");
  const [selectedSquare, setSelectedSquare] = useState<null | [number, number]>(
    null
  );
  const [selectedTile, setSelectedTile] = useState<null | [number, number]>(
    null
  );

  const transformedBoard = useMemo(() => {
    if (isWhite || !room.board) return room.board;
    return flipBoard(room.board);
  }, [room.board]);

  const opponentBoard = flipBoard(transformedBoard);

  // Does not include all details for special moves, but shouldn't matter
  // for king calculations
  const possibleDestinationsForOpponent: [number, number][] =
    getPossibleOpponentMoveLocations({
      board: opponentBoard,
      userColor,
      turn: isTurn ? room.turn + 1 : room.turn,
    }).map((destination) => [7 - destination[0], 7 - destination[1]]);

  const isPlayerKingInCheck = getIsKingInCheck(
    transformedBoard,
    userColor,
    possibleDestinationsForOpponent
  );

  const possibleDestinationsForPlayer = getPossibleOpponentMoveLocations({
    board: transformedBoard,
    userColor: opponentColor,
    turn: isTurn ? room.turn : room.turn + 1,
    isPlayerKingInCheck,
  });

  const isOpponentKingInCheck = getIsKingInCheck(
    transformedBoard,
    opponentColor,
    possibleDestinationsForPlayer
  );

  const availablePieceMoves = selectedSquare
    ? getAvailableMoves({
        board: transformedBoard,
        square: selectedSquare,
        turn: isTurn ? room.turn : room.turn + 1,
        isPlayerKingInCheck,
      })
    : [];

  const availableTileMoves = selectedTile
    ? getAvailableTileMoves({
        board: transformedBoard,
        tile: selectedTile,
        turn: isTurn ? room.turn : room.turn + 1,
        isPlayerKingInCheck,
      })
    : [];

  // const tiles = useMemo(() => {
  //   const tiles = [TileState, PlayerColor][][];

  //   room.board.forEach()
  // })

  const makePieceMove = (square: [number, number]) => {
    websocket?.emit("ROOM_GAME_MAKE_MOVE", {
      id: room.id,
      fromSquare: selectedSquare,
      toSquare: square,
    });

    setSelectedSquare(null);
  };

  const makeTileMove = (tile: [number, number]) => {
    websocket?.emit("ROOM_GAME_MAKE_TILE_MOVE", {
      id: room.id,
      fromTile: selectedTile,
      toTile: tile,
    });

    setSelectedTile(null);
  };

  return (
    <div className="grid place-items-center h-screen w-screen p-4">
      <div>
        <div className="border-2 border-solid w-fit">
          {TILES.map((_, tileRowIndex) => (
            <div key={tileRowIndex} className="grid grid-cols-4">
              {TILES.map((_, tileColumnIndex) => {
                const rowSquares = new Array(2)
                  .fill(tileRowIndex)
                  .map((tileIndex, index) => tileIndex * 2 + index);
                const columnSquares = new Array(2)
                  .fill(tileColumnIndex)
                  .map((tileIndex, index) => tileIndex * 2 + index);

                const availableMove = availableTileMoves.find(
                  (move) =>
                    move[0] === tileRowIndex && move[1] === tileColumnIndex
                );

                const isSelectedTile =
                  selectedTile?.[0] === tileRowIndex &&
                  selectedTile?.[1] === tileColumnIndex;

                return (
                  <div
                    className={clsx(
                      "tile-size border-1 border-black border-solid relative transition-all",
                      {
                        "shadow-2xl -translate-y-1": isSelectedTile,
                      }
                    )}
                    onClick={() => {
                      if (moveMode !== "tile") return;

                      console.log(moveMode);

                      if (!!availableMove) {
                        makeTileMove([tileRowIndex, tileColumnIndex]);
                        return;
                      }

                      setSelectedTile([tileRowIndex, tileColumnIndex]);
                    }}>
                    {isSelectedTile && (
                      <div className="absolute shadow-xl inset-0 z-10 pointer-events-none"></div>
                    )}
                    {!!availableMove && (
                      <div className="absolute inset-0 pointer-events-none grid place-items-center z-10">
                        <div
                          className={clsx("rounded-full size-4", {
                            "bg-blue-600": isTurn,
                            "bg-gray-600": !isTurn,
                          })}
                        />
                      </div>
                    )}
                    {rowSquares.map((rowIndex) => (
                      <div key={rowIndex} className="grid grid-cols-2">
                        {columnSquares.map((columnIndex) => {
                          const squareId = isWhite
                            ? getSquareId(rowIndex, columnIndex)
                            : getReversedSquareId(rowIndex, columnIndex);
                          const square = room.board.get(squareId);

                          const isWhiteSquare =
                            (rowIndex + columnIndex) % 2 === 0;

                          const isUserPiece =
                            (isWhite && square?.color === PLAYER_COLOR.WHITE) ||
                            (isBlack && square?.color === PLAYER_COLOR.BLACK);

                          const isSelected =
                            rowIndex === selectedSquare?.[0] &&
                            columnIndex === selectedSquare?.[1];

                          const availableMove = availablePieceMoves.find(
                            (move) =>
                              move[0] === rowIndex && move[1] === columnIndex
                          );

                          const isSquarePlayerKingInCheck =
                            isPlayerKingInCheck &&
                            square?.color === userColor &&
                            square.state === TILE_STATE.KING;
                          const isSquareOpponentKingInCheck =
                            isOpponentKingInCheck &&
                            square?.color !== userColor &&
                            square?.state === TILE_STATE.KING;

                          const isKingInCheck =
                            isSquarePlayerKingInCheck ||
                            isSquareOpponentKingInCheck;

                          const isDestinationForOpponent =
                            possibleDestinationsForOpponent.some(
                              (destination) => {
                                return (
                                  destination[0] === rowIndex &&
                                  destination[1] === columnIndex
                                );
                              }
                            );

                          const isDestinationForPlayer =
                            possibleDestinationsForPlayer.some(
                              (destination) => {
                                return (
                                  destination[0] === rowIndex &&
                                  destination[1] === columnIndex
                                );
                              }
                            );

                          return (
                            <GameBoardSquare
                              key={`${rowIndex}:${columnIndex}`}
                              onClick={() => {
                                if (
                                  availableMove &&
                                  !!selectedSquare &&
                                  isTurn
                                ) {
                                  makePieceMove([rowIndex, columnIndex]);
                                  return;
                                }

                                if (moveMode === "piece") {
                                  if (isUserPiece) {
                                    setSelectedSquare([rowIndex, columnIndex]);
                                  } else {
                                    setSelectedSquare(null);
                                  }
                                  return;
                                }
                              }}
                              square={square!}
                              isWhiteSquare={isWhiteSquare}
                              isAvailableMove={!!availableMove}
                              isKingInCheck={isKingInCheck}
                              isSelected={isSelected}
                              isTurn={isTurn}
                            />
                          );
                        })}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div className="flex gap-2 items-center justify-center w-full mt-4">
          <Button
            onClick={() => {
              setMoveMode("piece");
              setSelectedTile(null);
            }}
            className={clsx({
              "border-solid bg-blue-100 border-blue-600": moveMode === "piece",
            })}>
            Piece
          </Button>
          <Button
            onClick={() => {
              setMoveMode("tile");
              setSelectedSquare(null);
            }}
            className={clsx({
              "border-solid bg-blue-100 border-blue-600": moveMode === "tile",
            })}>
            Tile
          </Button>
        </div>
      </div>
    </div>
  );
}

function GameInProgressSpectatorView() {
  const websocket = useWebsocketContext();
  const room = useGameStore((store) => store.room)!;

  return (
    <div className="grid place-items-center h-screen w-screen p-4">
      <div>
        <div className="border-4 border-solid w-fit">
          {SQUARES.map((_, rowIndex) => (
            <div key={rowIndex} className="grid grid-cols-8">
              {SQUARES.map((_, columnIndex) => {
                const square = room.board.get(
                  getSquareId(rowIndex, columnIndex)
                );

                const isWhiteSquare = (rowIndex + columnIndex) % 2 === 0;

                return (
                  <GameBoardSquare
                    key={`${rowIndex}:${columnIndex}`}
                    square={square!}
                    isWhiteSquare={isWhiteSquare}
                  />
                );
              })}
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center mt-4">
          <Link to="/">
            <Button
              onClick={() => {
                websocket?.emit("ROOM_LEAVE");
              }}>
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

function GameOverView() {
  const websocket = useWebsocketContext();
  const room = useGameStore((store) => store.room)!;

  const winnerColor =
    room.winnerColor === PLAYER_COLOR.WHITE ? "White" : "Black";

  return (
    <div className="grid place-items-center h-screen w-screen p-4">
      <div>
        <div className="flex flex-col items-center justify-center gap-2 mb-8">
          <div className="font-handwriting text-2xl text-center">
            {winnerColor} is the winner!
          </div>
          <Link to="/">
            <Button
              onClick={() => {
                websocket?.emit("ROOM_LEAVE");
              }}>
              Back to Home
            </Button>
          </Link>
        </div>
        <div className="border-4 border-solid w-fit">
          {SQUARES.map((_, rowIndex) => (
            <div key={rowIndex} className="grid grid-cols-8">
              {SQUARES.map((_, columnIndex) => {
                const square = room.board.get(
                  getSquareId(rowIndex, columnIndex)
                );

                const isWhiteSquare = (rowIndex + columnIndex) % 2 === 0;

                return (
                  <GameBoardSquare
                    key={`${rowIndex}:${columnIndex}`}
                    square={square!}
                    isWhiteSquare={isWhiteSquare}
                  />
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function RoomRoute() {
  const userId = useGameStore((store) => store.userId);
  const room = useGameStore((store) => store.room);

  if (!room) {
    return <HasNotJoinedRoomView />;
  }

  if (room.state === "waiting" || !room.board) {
    return <WaitingRoomView />;
  }

  const isPlayer = room.userIds.includes(userId!);

  if (room.turn === -1 && isPlayer) {
    return <TileRemovalView />;
  }

  if (room.state === "started" && isPlayer) {
    return <GameInProgressView />;
  }

  if (room.state === "started") {
    return <GameInProgressSpectatorView />;
  }

  if (room.state === "finished") {
    return <GameOverView />;
  }

  return <div>hey</div>;
}
